<template>
  <v-data-table
    :headers="headers"
    :items="items"
    item-key="id"
    must-sort
    :no-results-text="$t('texts.jobsTablePlaceholder')"
    :no-data-text="$t('texts.jobsTableNoEntries')"
    :loading="loading"
    :hide-default-footer="items.length <= 5 || this.loading"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip color="info" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fav icon class="mx-0"
            :to="{
              name: 'company.jobs.edit',
              params: { id: item.id, job: item, company: company }
            }"
          >
            <v-icon color="primary">edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.edit') }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');
const { mapState: mapCompanyJobsState, mapActions: mapCompanyJobsActions } = createNamespacedHelpers('company/jobs');

export default {
  name: 'TableJobs',
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
  },
  data() {
    return {
      jobUpdateId: null,
    };
  },
  computed: {
    ...mapCompanyJobsState([
      'storeJobPending',
    ]),
    ...mapCompanyProfileState([
      'company',
    ]),
    headers() {
      const headers = [
        {
          text: this.$i18n.t('texts.label'),
          value: 'title',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.applications'),
          value: 'number_of_applications',
          align: 'left',
        },
        {
          text: '',
          value: 'actions',
          align: 'right',
          sortable: false,
        },
      ];
      return headers;
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyJobsActions([
      'storeJob',
    ]),
    triggerVisibility(job, index) {
      const newJob = { ...job };
      newJob.status = newJob.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
      this.jobUpdateId = index;
      this.storeJob({
        companyId: this.selectedCompanyId,
        form: newJob,
      }).finally(() => {
        this.jobUpdateId = null;
      });
    },
  },
};
</script>
